export default __webpack_public_path__ + "static/media/IconStar.1aeb2d3b.svg";